import * as React from 'react';
import { FieldProps } from '../metadataFormField';
import { DatePicker } from '../../DatePicker/datePicker';
import { formatDate, getFieldValue, parseDate } from '../../../utils';
import { FieldGroup } from '../FieldGroup/fieldGroup';

export const DateField = (props: FieldProps) => {
  const { field, data, updater } = props;
  const { updateField, updateData } = updater;
  const value = getFieldValue(field, data);
  return (
    <FieldGroup {...props} value={formatDate(value)}>
      <DatePicker
        selected={value}
        onChange={date => {
          const val = formatDate(date, true);
          updateField(field, val);
          updateData(field, val);
        }}
        showPopperArrow={false}
        popperPlacement="bottom-start"
      />
    </FieldGroup>
  );
};
